<template>
  <div class="skeleton-card relative h-full min-h-[350px] flex items-center justify-center overflow-hidden rounded-2 bg-white 4xl:min-h-[485px] 5xl:min-h-[535px]">
    <div role="status" class="skeleton-animate mb-auto max-w-full w-full">
      <div class="min-h-[160px] flex items-center justify-center rounded-2 bg-gray-300">
        <svg class="h-10 w-10 text-gray-200" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 20">
          <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z" />
          <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" />
        </svg>
      </div>
      <div class="mb-2 min-h-[17px] flex flex-wrap translate-y-[-50%] items-center gap-1.5 px-4 md:px-6" />
      <div class="min-h-[224.78px] px-4 pb-5 md:px-6">
        <div class="mb-4 h-2.5 w-48 rounded-full bg-gray-200" />
        <div class="mb-2.5 h-2 rounded-full bg-gray-200" />
        <div class="mb-2.5 h-2 rounded-full bg-gray-200" />
        <div class="h-2 rounded-full bg-gray-200" />
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="highlight-animate absolute h-full w-[100px] bg-white/25" />
  </div>
</template>
